<div class="container-fluid">
  <div class="row">

   <!-- 小螢幕上方橫向滑動選單 -->
   <div class="mobile-menu-wrapper d-lg-none">
    <div class="mobile-menu-scroll">
      <div class="mobile-menu">
        <button
          class="mobile-menu-btn"
          *ngFor="let btn of menuButtons"
          [title]="btn.tooltip"
          [class.active-button]="btn.isActive"
          (click)="handleMenuButtonClick(btn)"
        >
          <i [class]="btn.icon"></i>
        </button>
      </div>
    </div>

  </div>

  <!-- 左側區塊 - 僅在大螢幕顯示 -->
  <div id="menudiv" class="col-auto d-none d-lg-flex flex-column align-items-center" [class.collapsed]="isMenuCollapsed">
    <!-- 切換按鈕 -->


    <!-- 原有菜單按鈕 -->
    <button
      class="btn btn-custom mb-2 d-flex flex-column align-items-center"
      *ngFor="let btn of menuButtons"
      [title]="btn.tooltip"
      [class.active-button]="btn.isActive"
      (click)="handleMenuButtonClick(btn)"
    >
      <i [class]="btn.icon"></i>
      <span class="btn-text small mt-1" *ngIf="!isMenuCollapsed">{{ btn.text }}</span>
    </button>

    <button
      class="btn btn-toggle mb-2 d-flex flex-column align-items-center"
      (click)="toggleMenuCollapse()"
      [title]="(isMenuCollapsed ? 'assistant.expand_menu' : 'assistant.collapse_menu') | translate"
    >
      <i class="fa-solid" [class.fa-angles-right]="isMenuCollapsed" [class.fa-angles-left]="!isMenuCollapsed"></i>
      <span class="btn-text small mt-1" *ngIf="!isMenuCollapsed">{{ (isMenuCollapsed ? 'assistant.expand' : '') | translate }}</span>
    </button>
  </div>

<div id="chatdiv" class="col-12 col-lg-10" *ngIf="showtarget === 'chat'">

  <div class="clear-conversation-container">
  <button class="clear-conversation-btn" (click)="clearmsg()" [title]="'assistant.clear_conversation' | translate">
    <i class="fa-solid fa-trash-alt"></i> {{ 'assistant.clear_conversation' | translate }}
  </button>
</div>
  <div id="chatcontainer" >

   <!-- <span class="close-icon" (click)="closeDiv()" *ngIf="!showintroduction">×</span> -->
  <!-- <i *ngIf="showintroduction && vector_store_id !== ''" class="fa-solid fa-sliders setup-icon"
    (click)="gotofilecenter()" title="Go to File Center"></i> -->

  <div id="Introduction" *ngIf="showintroduction">

    <div class="container" style="margin-left: 0px">
      <div *ngIf="init_image" class="image-column">
        <img  [src]="init_image" width="150px" alt="image">
        <!-- <div *ngIf="!init_image" class="assistant_imagebyword">R</div> -->
      </div>

      <div class="text-column">
        <p [innerHTML]="init_word"></p>
        <div class="menubuttondiv">
          <button class="p-button p-component p-element p-button inline-btn p-button-primary mr-2 my-1"
            style="margin-right: 5px;" *ngFor="let item of init_meun"
            (click)="menubuttonclick(item.title,item.content,item.functionname)" [disabled]="!item.enable">
            {{ item.title }}
          </button>
        </div>

      </div>
    </div>
  </div>

  <div id="chat-container" class="chat-container">
    <div *ngFor="let message of chatMessages; let i = index" [ngClass]="message.role">

      <div *ngIf="message.role === 'assistant'" class="assistant-message">
        <div class="icon-column">
          <img src="{{ chatavator }}" alt="Assistant Icon" class="assistant-icon" />
        </div>
        <div class="content-column">
          <app-markdown-viewer [markdownContent]="message.content"></app-markdown-viewer>
          <ng-container #dynamicComponentContainers></ng-container>
        </div>
      </div>

      <!-- 用戶的訊息 -->
      <div *ngIf="message.role === 'user'">
        <div class="image-preview" *ngIf="!!message.images && message.images.length > 0">
          <a *ngFor="let img of message.images" [href]="img" target="_blank">
            <img [src]="img" alt="Sent Image" />
          </a>
        </div>
        <div [innerHTML]="message.content"></div>
      </div>
    </div>

    <div class="button-set" *ngIf="actionbuttons && actionbuttons.length > 0">
      <button
        *ngFor="let btn of actionbuttons"
        class="p-button p-component p-element p-button inline-btn p-button-primary mr-2 my-1"
         (click)="btn.action && btn.action()"
      >
        {{ btn.text }}
      </button>
    </div>
  </div>


  <div id="centerdiv">

    <div class="chat-input-container">

      <div class="image-preview-container" *ngIf="imagePreviews.length > 0">
        <div class="image-preview" *ngFor="let preview of imagePreviews; let i = index">
          <div class="image-wrapper">

            <a *ngIf="!preview.uploading" [href]="preview.url" target="_blank" [title]="preview.filename">
              <img [src]="preview.url" alt="Image Preview" />
            </a>

            <!-- 移除圖片按鈕 -->
            <button *ngIf="!preview.uploading" class="remove-image-button" (click)="removeImage(i)">
              <i class="fa-solid fa-x"></i>
            </button>
          </div>
        </div>
      </div>


      <div class="input-area">
        <!-- 工具按鈕容器 -->
        <div class="tools-container">
          <!-- 上傳檔案按鈕 -->
          <button *ngIf="tools_fileupload" type="button" class="upload-button" (click)="triggerFileUpload()" [title]="'assistant.upload_file' | translate">
            <i class="fa-solid fa-paperclip"></i>
          </button>

          <!-- 選擇檔案按鈕 -->
          <button type="button" *ngIf="tools_filepicker" class="filepicker-button" [class.active]="isFilePickerActive" (click)="toggleFilePicker()" [title]="'assistant.select_file' | translate">
            <i class="fa-solid fa-file"></i>
          </button>

          <!-- 搜尋知識庫按鈕 -->
          <button *ngIf="tools_filesearch && vector_store_lists.length > 0" [class.active]="isFileSearchActive" type="button" class="filesearch-button"
            (click)="filesearch()" [title]="'assistant.search_knowledge_base' | translate">
            <i class="fa-solid fa-database"></i>
          </button>

          <!-- 搜尋網頁按鈕 -->
          <button *ngIf="tools_websearch" type="button" class="websearch-button" [class.active]="isWebSearchActive"
            (click)="websearch()" [title]="'assistant.search_web' | translate">
            <i class="fa-solid fa-globe"></i>
          </button>

          <!-- MCP Server 按鈕 -->
          <button *ngIf="tools_mcpserver" type="button" class="tool-button" [title]="'assistant.mcp_server_active' | translate" [class.active]="true">
            <i class="fa-solid fa-server"></i>
          </button>
        </div>

        <!-- 隱藏的檔案上傳框 -->
         <!-- 隱藏的檔案上傳框 -->
<input type="file" accept=".jpg, .jpeg, .png, .pdf" id="fileInput" (change)="onFilesSelected($event)" multiple hidden />

        <!-- 输入区域包含标签显示 -->
        <div class="textarea-container">
          <!-- 已選檔案標籤 -->
          <div class="selected-files-tags" *ngIf="fileSelectedFiles.length > 0">
            <span class="file-tag" *ngFor="let file of fileSelectedFiles">
              #{{ file.filename }}
            </span>
          </div>
          <!-- 选择的数据库标签 -->
          <!-- <div class="selected-tags" *ngIf="selectedDatabases.length > 0">
            <span class="tag" *ngFor="let db of selectedDatabases; let i = index">
              {{ db }}
              <button class="tag-remove" (click)="removeDatabase(i)">&times;</button>
            </span>
          </div> -->

          <!-- 修改文本框，添加条件类 -->
          <textarea class="inputtextarea" [(ngModel)]="userMessage" [class.expanded]="isFileSearchActive"
          [placeholder]="(
            isWebSearchActive ? 'assistant.web_search_placeholder' :
            isFileSearchActive ? 'assistant.rag_search_placeholder' :
            'assistant.ask_anything'
          ) | translate"
          (input)="autoResize($event)" (keydown)="onKeyDown($event)"></textarea>
        </div>

        <!-- 送出按鈕固定在右下角 -->
        <button type="button" class="send-button" (click)="chatwithAI(userMessage)" [disabled]="isSendingMessage">
          <span *ngIf="isSendingMessage" class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
          <span *ngIf="!isSendingMessage">➤</span>
        </button>
      </div>

      <!-- RAG 数据库选择列表 -->
      <div  class="rag-database-list" *ngIf="isFileSearchActive">
        <div class="rag-options">
          <button *ngFor="let db of vector_store_lists"
                  class="rag-option"
                  [class.selected]="db.id === selectedDatabaseId"
                  (click)="selectDatabase(db.id)">
            {{ db.name }}
          </button>
        </div>
      </div>

      <!-- 檔案選擇區塊（直接顯示在對話框下方） -->
<div *ngIf="isFilePickerActive" class="filepicker-panel rag-database-list" style="margin-top: 12px;">
  <div class="filepicker-header">
    <span class="filepicker-title">{{ 'assistant.select_file' | translate }}</span>
    <button type="button" class="btn-close" (click)="closeFilePicker()"></button>
  </div>
  <div class="filepicker-body">
    <div class="mb-2">
      <input type="text" class="form-control" [(ngModel)]="fileTagFilter" [placeholder]="'assistant.keyword' | translate">
    </div>
    <div style="max-height:300px;overflow:auto;">
      <table class="table table-sm table-bordered align-middle">
        <thead>
          <tr>
            <th style="width:40px"></th>
            <th>{{ 'assistant.file_name' | translate }}</th>
            <!-- <th>ID</th> -->
            <th>{{ 'assistant.tags' | translate }}</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let file of filteredFileList">
            <td>
              <input type="checkbox" [checked]="isFileSelected(file)" (change)="toggleFileSelection(file)">
            </td>
            <td>
              <ng-container *ngIf="file.azureUrl; else plainFilename">
                <a href="javascript:void(0)" (click)="openExternalLink(file.azureUrl)" class="text-primary">
                  {{ file.filename }}
                </a>
              </ng-container>
              <ng-template #plainFilename>{{ file.filename }}</ng-template>
            </td>
            <!-- <td>{{ file.id }}</td> -->
            <td>
              <span *ngFor="let tag of file.tags" class="badge bg-primary me-1">{{ tag }}</span>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
  <div class="filepicker-footer">
    <button type="button" class="btn btn-secondary" (click)="closeFilePicker()">{{ 'assistant.cancel' | translate }}</button>
    <!-- <button type="button" class="btn btn-primary" (click)="insertSelectedFilesToMessage()" [disabled]="fileSelectedFiles.length === 0">插入檔案</button> -->
  </div>
</div>



    </div>

  </div>
</div>

<!-- <div  #filebankcontainer ></div> -->


</div>



<!-- <app-filebank *ngIf="showtarget == 'file'" [vector_store_id]="vector_store_id"></app-filebank> -->


<div id="pagediv" class="col-12 col-lg-10" *ngIf="showtarget === 'page'">

</div>
</div>
</div>




